import type { Home } from '@lmc/ts-common'
import { getNominative } from 'common/utils'
import type { FC } from 'react'
import { useSelector } from 'react-redux'

type Props = { isGP?: boolean }

export const Success: FC<Props> = ({ isGP }) => {
  const preferredPeopleNominative: string = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative || ''
  )

  const preferredResidentTerm = getNominative(
    preferredPeopleNominative,
    'Residents'
  )

  return (
    <div className="signature-modal-vertial-center">
      <div>
        <p
          style={{
            transition: 'all 0.2s',
            fontWeight: 700,
            fontSize: 16
          }}
        >
          {isGP
            ? `You now have clinical access and are able to see GP Connect records for ${preferredResidentTerm} who have consented`
            : ' A signature has been added to the timeline.'}
        </p>
      </div>
    </div>
  )
}

export default Success
